import React, { useEffect, useState } from 'react';
import { Button, Grid, Paper, TextField } from '@material-ui/core';
import ViewIcon from '@material-ui/icons/Visibility';
import { Autocomplete } from '@material-ui/lab';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/DeleteForever';
import {
  filterSamplesByFilterSource,
  handleFilterBySource,
  handleViewPredictionsData,
} from '../PredictionFilterUtils';

const PredictionsFilterByImageSource = ({
  classes,
  loading,
  onDelete,
  onViewSamples,
  onRelabelSamples,
  allSamplesData,
}) => {
  const [predictionsToView, setPredictionsToView] = useState([]);
  const [uniqueImageSourceLabelsList, setUniqueImageSourceLabelsList] =
    useState([]);
  const [ImageSourceLabelChosen, setImageSourceLabelChosen] = useState(false);

  const filterSource = 'img_source';

  const handleFilterByImageSource = (e, val, reason) => {
    handleFilterBySource(
      e,
      val,
      reason,
      allSamplesData,
      setImageSourceLabelChosen,
      setPredictionsToView,
      filterSource
    );
  };

  const handleViewPredictions = () => {
    handleViewPredictionsData(predictionsToView, onViewSamples, filterSource);
  };

  useEffect(() => {
    filterSamplesByFilterSource(
      allSamplesData,
      setUniqueImageSourceLabelsList,
      filterSource
    );
  }, [allSamplesData]);

  return (
    <Paper className={classes.paper}>
      <Grid className={classes.bold} container justifyContent="center">
        Filter by Image Source:
      </Grid>
      <Grid container justifyContent="space-around" alignItems="center">
        <Autocomplete
          onChange={(e, val, reason) => {
            handleFilterByImageSource(e, val, reason);
          }}
          options={uniqueImageSourceLabelsList}
          getOption={(option) => option ?? ''}
          style={{ width: 300 }}
          renderInput={(params) => (
            <TextField {...params} label="Image Source" variant="outlined" />
          )}
        />
      </Grid>
      <Grid className={classes.labelWithValue}>
        Samples:
        <span className={classes.number}>
          {predictionsToView?.length || allSamplesData?.length}
        </span>
      </Grid>
      <Grid className={classes.labelWithValue}>
        Labels:
        <span className={classes.number}>
          {ImageSourceLabelChosen ? 1 : uniqueImageSourceLabelsList?.length}
        </span>
      </Grid>
      <Grid container justifyContent="center" alignItems="center" spacing={2}>
        <Grid item>
          <Button
            size="large"
            disabled={loading}
            className={classes.blueButton}
            variant="contained"
            endIcon={<ViewIcon />}
            disableElevation
            onClick={handleViewPredictions}
          >
            View
          </Button>
        </Grid>
        <Grid item>
          <Button
            size="large"
            disabled={loading}
            className={classes.darkBlueButton}
            variant="contained"
            endIcon={<EditIcon />}
            disableElevation
            onClick={onRelabelSamples}
          >
            Re-Label
          </Button>
        </Grid>
        <Grid item>
          <Button
            size="large"
            disabled={loading}
            className={classes.redButton}
            variant="contained"
            endIcon={<DeleteIcon />}
            disableElevation
            onClick={onDelete}
          >
            Delete
          </Button>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default PredictionsFilterByImageSource;
